import React from 'react';
import logo from "../../../assets/images/TCS-logo.png";
import T from 'prop-types';

export const Logo = ({ className }) => {
    return <img src={logo} className={className} alt="Logo image" />;
};

Logo.T = {
    className: T.string,
};

Logo.defaultProps = {
    className: 'logoDefaultCls',
};
